<template>
  <layout-full>
    <!-- Тот же принцип, что в LayoutVertical: полоса в обычном потоке страницы
         (здесь макет вообще без закреплённых элементов, так что риска нет). -->
    <new-cabinet-banner />
    <router-view />
  </layout-full>
</template>

<script>
import LayoutFull from '@core/layouts/layout-full/LayoutFull.vue'
import NewCabinetBanner from '@/components/NewCabinetBanner.vue'

export default {
  components: {
    LayoutFull,
    NewCabinetBanner,
  },
}
</script>
